import React, { useCallback, useMemo } from "react";
import DatePicker from "react-date-picker";
import type { InputProps } from "reactstrap";
import type { WrappedFieldInputProps } from "redux-form";
import styled from "styled-components";
import { DateToLocalDate, LocalDateToDate } from "src/utilities/DateUtils";
import "src/shared/components/calendar/ReactCalendarStyles";

export interface DatePickerRendererProps extends InputProps {
  input: WrappedFieldInputProps;
}

export const DatePickerRenderer = (props: DatePickerRendererProps) => {
  const { input, disabled, invalid } = props;
  const { name, onChange, value } = input;

  const handleChange = useCallback(
    (value) => {
      onChange(DateToLocalDate(value));
    },
    [onChange],
  );

  const dateValue = useMemo(() => {
    return LocalDateToDate(value);
  }, [value]);

  return (
    <DatePickerStyled
      name={name}
      className={`${invalid ? "is-invalid" : ""} form-control`}
      onChange={handleChange}
      value={dateValue}
      disabled={disabled}
      clearIcon={null}
      showLeadingZeros
      required
      locale="en-UK"
    />
  );
  // en-CA doesn't work here.
};

const DatePickerStyled = styled(DatePicker)`
  .react-date-picker__button {
    border: none;
  }
  .react-date-picker__wrapper {
    border: none;
  }
  .react-date-picker__calendar {
    z-index: 10;
  }
`;
